import SC from "./style";
import { useState, useEffect } from "react";
import { Button, Loader } from "InnoUI/components";
import theme from "theme";
import InnoIcons from "InnoUI/innoicons";
import { useDispatch } from "react-redux";
import { apiPost } from "api/callApi";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { InputField } from "@components/";
import { regexTypes } from "utils/config";
import { showAlert } from "utils/helper";

function AddEditHoliday(props) {
  const { onClose, fetchdata, rowData, selectedTab } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState();

  useEffect(() => {
    const newData = { ...rowData, date: rowData.startDate };
    setData(newData);
  }, [rowData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await apiPost(`/v1/editholiday/${rowData.id}`, data);
      showAlert({ title: "Success", text: result?.message, icon: "success" });

      await fetchdata();
      onClose();
    } catch (error) {
      console.log(error);

      showAlert({
        title: "Error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
    }
  };

  const handleChange = (property, value) => {
    setData((prevData) => {
      const updatedData = {
        ...prevData,
        [property]: value,
      };

      // Update totalNoOfDays only if startDate or endDate changes
      if (property === "startDate" || property === "endDate") {
        updatedData.totalNoOfDays = calculateTotalDays(
          property === "startDate" ? value : prevData.startDate,
          property === "endDate" ? value : prevData.endDate
        );
      }

      return updatedData;
    });
  };

  const calculateTotalDays = (start, end) => {
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const timeDiff = endDate - startDate;
      return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;
    }
    return 0;
  };

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>Edit Holiday</SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>
      {loading && <Loader />}
      <SC.Form onSubmit={handleSubmit}>
        <SC.FormWrapper>
          {/* Holiday Name Input */}
          <SC.LabelContainer>
            <SC.Label>
              Holiday Name <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <InputField
                name="holidayName"
                value={data?.holidayName || ""}
                type="text"
                style={{ width: "90%", height: "29px" }}
                onChange={handleChange}
                required
                regexType={regexTypes.textOnly}
              />
            </SC.Children>
          </SC.LabelContainer>

          {/* Conditional Rendering based on Holiday Type */}
          {selectedTab == "0" ? (
            // Public Holiday Fields
            <SC.LabelContainer>
              <SC.Label>Date</SC.Label>
              <SC.Children>
                <DatePicker
                  name="date"
                  placeholder="Please Select"
                  value={data?.date ? dayjs(data?.date, "YYYY-MM-DD") : null}
                  format="YYYY-MM-DD"
                  onChange={(value) => {
                    // Ensure we only pass the date part
                    const formattedDate = value
                      ? dayjs(value).format("YYYY-MM-DD")
                      : "";
                    handleChange("date", formattedDate);
                  }}
                  mode="date"
                  showTime={false}
                  allowClear={true}
                  style={{ width: "90%", height: "30px", borderRadius: 0 }}
                />
              </SC.Children>
            </SC.LabelContainer>
          ) : (
            <>
              <SC.LabelContainer>
                <SC.Label>Start Date</SC.Label>
                <SC.Children>
                  <DatePicker
                    name="startDate"
                    placeholder="Please Select"
                    value={
                      data?.startDate
                        ? dayjs(data?.startDate, "YYYY-MM-DD")
                        : null
                    }
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                      // Ensure we only pass the date part
                      const formattedDate = value
                        ? dayjs(value).format("YYYY-MM-DD")
                        : "";
                      handleChange("startDate", formattedDate);
                    }}
                    mode="date"
                    showTime={false}
                    allowClear={true}
                    style={{ width: "90%", height: "30px", borderRadius: 0 }}
                    disabledDate={(current) =>
                      current && current > dayjs(data?.endDate, "YYYY-MM-DD")
                    }
                  />
                </SC.Children>
              </SC.LabelContainer>

              <SC.LabelContainer>
                <SC.Label>End Date</SC.Label>
                <SC.Children>
                  <DatePicker
                    name="endDate"
                    placeholder="Please Select"
                    value={
                      data?.endDate ? dayjs(data?.endDate, "YYYY-MM-DD") : null
                    }
                    format="YYYY-MM-DD"
                    onChange={(value) => {
                      // Ensure we only pass the date part
                      const formattedDate = value
                        ? dayjs(value).format("YYYY-MM-DD")
                        : "";
                      handleChange("endDate", formattedDate);
                    }}
                    mode="date"
                    showTime={false}
                    allowClear={true}
                    style={{ width: "90%", height: "30px", borderRadius: 0 }}
                    disabledDate={(current) =>
                      current && current < dayjs(data?.startDate, "YYYY-MM-DD")
                    }
                  />
                </SC.Children>
              </SC.LabelContainer>
              <SC.LabelContainer>
                <SC.Label>Total No of Days</SC.Label>
                <SC.Children>
                  <p>{data?.totalNoOfDays} days</p>
                </SC.Children>
              </SC.LabelContainer>
            </>
          )}

          {/* Buttons */}
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: "#f7f9f7",
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
            <Button
              caption={"Save"}
              type="submit"
              isLoading={loading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
            />
          </SC.ButtonContainer>
        </SC.FormWrapper>
      </SC.Form>
    </>
  );
}

export default AddEditHoliday;
